<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                @if (action === "NEW") {
                    {{ "PROJECTS.NotificationChannelNew" | translate }}
                }
                @if (action === "EDIT") {
                    {{ "PROJECTS.NotificationChannelEdit" | translate }}
                }
            </span>

            <div class="header-actions">
                <button mat-raised-button type="button" class="btn-save" (click)="save()" [disabled]="channelForm.invalid">
                    {{ "PROJECTS.NotificationChannelSave" | translate }}
                </button>

                <button mat-raised-button type="button" (click)="cancel()">
                    {{ "PROJECTS.CANCEL" | translate }}
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="dialog-content p-24 m-0" fusePerfectScrollbar>
        <form name="channelForm" [formGroup]="channelForm" class="channel-form w-100-p" fxLayout="column" fxFlex>
            <div class="section section--row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ "PROJECTS.NotificationChannelName" | translate }}</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ "PROJECTS.NotificationChannelTypeLabel" | translate }}</mat-label>
                    <mat-select formControlName="type">
                        @for (type of notificationChannelTypes; track type) {
                            <mat-option [value]="type">
                                {{ getChannelTypeLabel(type) }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            @if (isChannelType("email")) {
                <div class="section">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "PROJECTS.NotificationChannelEmails" | translate }}</mat-label>
                        <textarea matInput formControlName="emailsInput" rows="3"></textarea>
                        <mat-hint>{{ "PROJECTS.NotificationChannelListHint" | translate }}</mat-hint>
                        @if (channelForm.get("emailsInput")?.hasError("listRequired") && channelForm.get("emailsInput")?.touched) {
                            <mat-error>{{ "PROJECTS.NotificationChannelEmailsRequired" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            }

            @if (isChannelType("sms")) {
                <div class="section">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "PROJECTS.NotificationChannelPhones" | translate }}</mat-label>
                        <textarea matInput formControlName="phoneNumbersInput" rows="3"></textarea>
                        <mat-hint>{{ "PROJECTS.NotificationChannelListHint" | translate }}</mat-hint>
                        @if (
                            channelForm.get("phoneNumbersInput")?.hasError("listRequired") &&
                            channelForm.get("phoneNumbersInput")?.touched
                        ) {
                            <mat-error>{{ "PROJECTS.NotificationChannelPhonesRequired" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            }

            @if (isChannelType("telegram")) {
                <div class="section">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "PROJECTS.NotificationChannelChatIds" | translate }}</mat-label>
                        <textarea matInput formControlName="chatIdsInput" rows="3"></textarea>
                        <mat-hint>{{ "PROJECTS.NotificationChannelListHint" | translate }}</mat-hint>
                        @if (channelForm.get("chatIdsInput")?.hasError("listRequired") && channelForm.get("chatIdsInput")?.touched) {
                            <mat-error>{{ "PROJECTS.NotificationChannelChatIdsRequired" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="section">
                    <p class="mat-body-2">{{ "PROJECTS.NotificationChannelTelegramManagedBot" | translate }}</p>
                </div>
            }

            @if (isChannelType("slack") || isChannelType("teams")) {
                <div class="section">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "PROJECTS.NotificationChannelWebhookUrl" | translate }}</mat-label>
                        <input matInput formControlName="webhookUrl" />
                        @if (hasStoredSecret("hasWebhookUrl")) {
                            <mat-hint>{{ "PROJECTS.NotificationChannelSecretStored" | translate }}</mat-hint>
                        }
                        @if (channelForm.get("webhookUrl")?.hasError("required") && channelForm.get("webhookUrl")?.touched) {
                            <mat-error>{{ "PROJECTS.NotificationChannelWebhookRequired" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            }

            @if (isChannelType("web_push")) {
                <div class="web-push-card">
                    <div class="section__help">
                        {{ "PROJECTS.NotificationChannelWebPushHelp" | translate }}
                    </div>
                </div>
            }

            @if (!isChannelType("web_push")) {
                <div class="section">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "PROJECTS.NotificationChannelLanguage" | translate }}</mat-label>
                        <mat-select formControlName="language">
                            @for (language of languageOptions; track language.id) {
                                <mat-option [value]="language.id">
                                    {{ language.label }}
                                </mat-option>
                            }
                        </mat-select>
                        <mat-hint>{{ "PROJECTS.NotificationChannelLanguageHint" | translate }}</mat-hint>
                    </mat-form-field>
                </div>
            }
        </form>
    </mat-dialog-content>
</div>
